export default __webpack_public_path__ + "static/media/logo.c62588b3.png";